<template>
  <b-col>
    <b-container class="px-0 pt-1">
      <b-row v-if="!isMobile()" id="not-found" class="text-center">
        <b-col cols="12" class="not-found-img">
          <img src="@/assets/404.png" />
        </b-col>
        <b-col cols="5" class="title-outline d-flex align-items-center justify-content-center">
          <span class="not-found-title">Página não encontrada</span>
        </b-col>
        <b-col cols="12" class="div-not-found-sub-title">
          <span class="not-found-sub-title text-center">Infelizmente a página que você está procurando não existe.</span>
        </b-col>
        <b-col cols="3" class="div-button-back-to-home d-flex align-items-center">
          <a type="button" href="/" class="button-back-to-home" title="Voltar">Voltar para a home</a>
        </b-col>
      </b-row>
      <b-row v-if="isMobile()" id="not-found" class="text-center">
        <b-col cols="12" class="not-found-img">
          <img src="@/assets/404-mobile.png" />
        </b-col>
        <b-col cols="10" md="7" sm="7" class="title-outline d-flex align-items-center justify-content-center">
          <span class="not-found-title">Página não encontrada</span>
        </b-col>
        <b-col cols="12" class="div-not-found-sub-title">
          <span class="not-found-sub-title text-center">Infelizmente a página que você <br v-if="!isTable()"> está procurando não existe.</span>
        </b-col>
        <b-col cols="7" sm="4" class="div-button-back-to-home d-flex align-items-center">
          <a type="button" href="/" class="button-back-to-home" title="Voltar">Voltar para a home</a>
        </b-col>
      </b-row>
    </b-container>
  </b-col>
</template>

<script>
import { isMobile, isTablet } from '@/utils/mobileUtils';

export default {
  name: 'NotFound',
  methods: {
    isMobile() {
      return isMobile();
    },
    isTable() {
      return isTablet();
    },
  },
};
</script>

<style lang="scss">
#not-found {
  padding-top: 60px;
}

.not-found-title {
  padding: 5px 0;
  font-size: 24px!important;
  font: normal normal bold 24px/29px UOLtext;
  letter-spacing: 0;
  color: #444444;
}
.title-outline {
  height: 40px;
  margin: 0 auto;
  border: 2px dashed #F19740;
  background: #FFFFFF 0 0 no-repeat padding-box;
  border-radius: 20px;
}

.div-not-found-sub-title{
  margin-top: 16.5px;
  margin-bottom: 44.5px;
}
.not-found-sub-title {
  margin-top: 16.5px;
  font-size: 18px;
  letter-spacing: 0;
  color: #000000;
}

.div-button-back-to-home {
  margin: 0 auto;
  height: 48px;
  background: #E38931 0 0 no-repeat padding-box;
  border-radius: 2px;
}
.button-back-to-home {
  font-size: 18px;
  letter-spacing: 0;
  color: #FFFFFF;
  margin: auto;
}
.button-back-to-home:hover {
  color: #FFFFFF;
  text-decoration: none;
}

@media screen and (max-width: 768px) {
  .not-found-title {
    padding: 0;
  }
  .div-not-found-sub-title{
    margin-bottom: 24.5px;
  }
  .copyright {
    padding-bottom: 0.5rem !important;
    padding-top: 0.9rem !important;
  }
}

@media screen and (max-width: 375px) {
  #not-found {
    padding-bottom: 60px;
  }
}

.app-content {
  min-height: 54vh!important;
  background-color: #FFF;
  @media screen and (min-width: $md) {
    min-height: 57vh!important;
  }
}
</style>
